export const formLocaleTexts = {
  requiredText: '入力して下さい。',
}
